import { Outlet } from "react-router-dom";
import SideBar from "../Components/Sidebar";

export default function Layout(){
    return (
        <div className='flex max-md:flex-col flex-1 gap-6 max-md:gap-0 bg-cover absolute w-full h-full'>
            <SideBar />
            <div className='p-6 pl-0 pb-0 max-md:p-2 flex flex-1 overflow-hidden flex-col'>
                <Outlet />
            </div>
        </div>
    )
}